import useSEO from "../../hooks/useSEO";
import GithubProjects from "../../api/githubApi";
import { motion } from "framer-motion";
import { pageVariants, sectionVariants } from "../../config/animations";

function Projects() {
  useSEO({
    title: "Projects",
    description: "浏览我的GitHub项目和作品集。查看我使用React, Node.js等技术构建的应用程序。",
    keywords: "projects, github, portfolio, web development, react projects",
    url: "https://wangyi.is-a.dev/projects"
  });

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={pageVariants}
      className="w-full"
    >
      <motion.div
        className="font-bold text-slate-800 dark:text-white w-full pb-4"
        variants={sectionVariants}
      >
        <div className="flex text-3xl gap-3 mb-2 font-bold items-center">
          <div className="bg-slate-800 h-[36px] w-2 rounded"></div>
          <h2>我的项目 📚</h2>
        </div>
        <p className="text-slate-700 dark:text-slate-300 font-normal">
          这是我曾经做过的一些项目。🎒
        </p>
      </motion.div>

      <motion.div variants={sectionVariants}>
        <GithubProjects username="wangyi68" />
      </motion.div>
    </motion.div>
  );
}

export default Projects;
